export default "__VITE_ASSET__BCahW5ue__"